<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemStoreType',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-store-type-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="类型名称">
                <a-input v-model:value="state.tableData.param.typeName" placeholder="请输入类型名称" :maxlength="50" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="类型分组">
                <a-input v-model:value="state.tableData.param.typeGroup" placeholder="请输入类型分组" :maxlength="50" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary"> <SearchOutlined />查询 </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary"> <RedoOutlined />重置 </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex justify-start md:justify-end">
                <ant-button class="add" @click="openDialog('add', {})" type="primary"> <PlusOutlined />新增类型 </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading" :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'status'">
            <a-tag :color="record.status === '1' ? 'success' : 'default'">
              {{ record.status === '1' ? '启用' : '禁用' }}
            </a-tag>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog('edit', record)">编辑</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination
        v-model:current="state.tableData.param.pageNum"
        v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total"
        :page-size-options="['10', '20']"
        show-size-changer
        :show-total="(total) => `共 ${total} 条`"
        :showQuickJumper="true"
        @change="onPageChange"
        @show-size-change="onShowSizeChange"
      />
    </a-card>
    <StoreTypeDialog ref="dialogRef" @create-update="createUpdate" />
  </div>
</template>

<script setup lang="ts" name="systemStoreType">
import { reactive, ref, onMounted, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStoreType } from '@/store/shop/storeType'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import StoreTypeDialog from './dialog.vue'

const storeTypeStore = useStoreType()
const dialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 80, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '类型名称', dataIndex: 'typeName', key: 'typeName', ellipsis: true },
  { title: '类型分组', dataIndex: 'typeGroup', key: 'typeGroup', ellipsis: true },
  { title: '排序', dataIndex: 'sortOrder', key: 'sortOrder', width: 100 },
  { title: '状态', key: 'status', width: 100 },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      typeName: '',
      typeGroup: ''
    }
  }
})

const resetFun = () => {
  state.tableData.param.typeName = ''
  state.tableData.param.typeGroup = ''
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => storeTypeStore.getStoreTypePage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (type: string, row: any) => {
  if (type === 'add') {
    dialogRef.value.openDialog(type, row)
  } else {
    storeTypeStore.getStoreTypeInfo(row.id).then((data: any) => {
      dialogRef.value.openDialog(type, data)
    })
  }
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除店铺类型："${row.typeName}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return storeTypeStore.deleteStoreType(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = () => {
  message.success('操作成功')
  getTableData()
  dialogRef.value.closeDialog()
}

onMounted(() => {
  getTableData()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
